import React, { Component } from "react";
import ConSideBarsJsx from "./sidebar.jsx"

import { Loader } from '../../../common/loader/loader.jsx';
import axios from "axios";
import { baseURL } from "../../../../constants/applicationConstants.js";

export class SideBarsJsxclass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responseData: null, role: false
    };
  }
  componentDidMount = () => {
    // this.setState({ isLoading: true })
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    //let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    let loginData = localStorage.getItem("loginData") && JSON.parse(localStorage.getItem("loginData"))
    if (token && loginData?.userId) {
      this.callDetails()
    }
  }
  callDetails = () => {
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    //let expertID = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    let loginData = localStorage.getItem("loginData") && JSON.parse(localStorage.getItem("loginData"))

    axios.get(`${baseURL}/user/${loginData?.userId}`, {
      headers: { 'x-access-token': token }
    }).then(res => {

      if (res?.data?.data?.role) {
        this.setState({ role: true })

      }
      this.setState({ responseData: res.data.data })
      // localStorage.setItem("legalName",res.data.data?.firstName);
      // localStorage.setItem("planName",res.data.data?.planName);

      this.setState({ isLoading: false })
    }).catch(err => {
      this.setState({ isLoading: false })
    })
  }
  render() {
    // Transforming the data to the desired structure
    let data = this.state.responseData?.role?.roleModules
    const transformedData = data?.map(moduleItem => ({
      moduleName: moduleItem?.modulePermission?.module.moduleName.replace(/\s+/g, ''),
      modulePermissions: moduleItem?.modulePermission?.slug
        
    }));
    const groupedData = transformedData?.reduce((acc, moduleItem) => {
      let { moduleName, modulePermissions } = moduleItem; // Destructure the module data
    
      // Remove spaces from moduleName
      moduleName = moduleName.replace(/\s+/g, '');
    
      if (!acc[moduleName]) {
        // If this moduleName doesn't exist yet in the accumulator, create it
        acc[moduleName] = [];
      }
    
      // Add the module permission to the relevant moduleName
      acc[moduleName].push(modulePermissions);
    
      return acc;
    }, {});
    
    
    
    data && localStorage.setItem("roleManager",JSON.stringify(groupedData))

    return (
      <div>
<ConSideBarsJsx response={this.state.responseData}
          transformedData={transformedData} />
      

        {this.state.isLoading && <Loader />}
      </div>
    );
  }
}

export default SideBarsJsxclass;